import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=e8e59b0c&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=e8e59b0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e59b0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8e59b0c')) {
      api.createRecord('e8e59b0c', component.options)
    } else {
      api.reload('e8e59b0c', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=e8e59b0c&scoped=true", function () {
      api.rerender('e8e59b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/WMS/sortingStation/DataForm.vue"
export default component.exports